/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type ShopGrid_landingPage$ref = any;
export type ShopGrid_landingPage = {
    readonly grid: {
        readonly items: ReadonlyArray<{
            readonly description: string | null;
            readonly imageUrl: string | null;
            readonly title: string | null;
            readonly url: string | null;
        } | null> | null;
    } | null;
    readonly " $refType": ShopGrid_landingPage$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ShopGrid_landingPage",
  "type": "LandingPage",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "grid",
      "storageKey": null,
      "args": null,
      "concreteType": "LandingPageGrid",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "items",
          "storageKey": null,
          "args": null,
          "concreteType": "LandingPageGridItem",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "description",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "imageUrl",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "url",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '33de3e3749d1393933583ebec1c40744';
export default node;
